import React, { useState, useEffect, useMemo, useCallback } from "react"
import { useHistory } from "react-router-dom"
import { SearchOutlined } from "@ant-design/icons"

import CustomTable from "../../../v2-components/Antd/Table"
import CustomSwitch from "../../../v2-components/Antd/Switch"
import CustomSpin from "../../../v2-components/Antd/Spin"
import CustomAlert from "../../../v2-components/Antd/Alert"

import { useUserService } from "../hooks/useUserService"
import "../styles/common.css"
import "../styles/tables.css"

const UsersTable = () => {
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const history = useHistory()
    const { fetchAllUsers } = useUserService()

    useEffect(() => {
        let isMounted = true

        const loadUsers = async () => {
            try {
                setLoading(true)
                const data = await fetchAllUsers()

                if (isMounted && data.length > 0) {
                    setUsers(data)
                    setError(null)
                }
            } catch (err) {
                if (isMounted) {
                    setError("Error al cargar los usuarios")
                    console.error(err)
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }

        loadUsers()

        return () => {
            isMounted = false
        }
    }, [fetchAllUsers])

    const handleViewUser = useCallback(
        (user) => {
            history.push(`/v2/user-management/users/${user.email}`, { userData: user })
        },
        [history]
    )

    const columns = useMemo(
        () => [
            {
                title: "Correo electrónico",
                dataIndex: "email",
                key: "email",
                sorter: (a, b) => a.email.localeCompare(b.email),
            },
            {
                title: "Rol",
                dataIndex: "roles",
                key: "roles",
                render: (roles) => (Array.isArray(roles) ? roles.join(", ") : roles),
            },
            {
                title: "Farmacia",
                dataIndex: "pharmacy",
                key: "pharmacy",
            },
            {
                title: "Estado",
                dataIndex: "eneable",
                key: "eneable",
                render: (enabled) => <CustomSwitch checked={enabled} disabled />,
            },
            {
                title: "Ver más",
                key: "actions",
                render: (_, record) => <SearchOutlined onClick={() => handleViewUser(record)} className="action-icon" />,
            },
        ],
        [handleViewUser]
    )

    if (loading && users.length === 0) {
        return (
            <div className="loading-container">
                <CustomSpin size="large" tip="Cargando usuarios..." />
            </div>
        )
    }

    if (error) {
        return <CustomAlert message={error} type="error" />
    }

    return (
        <div className="page-container">
            <div className="content-box">
                <div className="table-container">
                    <CustomTable
                        columns={columns}
                        dataSource={users}
                        rowKey="email"
                        loading={loading}
                        pagination={{
                            pageSize: 8,
                        }}
                        className="custom-table"
                    />
                </div>
            </div>
        </div>
    )
}

export default React.memo(UsersTable)
